// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FAB__fabContainer___B78WX{bottom:0;display:block;padding:0 16px 16px 0;position:fixed;right:0;transition:opacity .5s ease-in-out;z-index:10000}.FAB__fabEnter___2GA_Y,.FAB__fabEnterActive___3HH_X,.FAB__fabExitActive___1YD43,.FAB__fabExitDone___2zlm9{opacity:0}.FAB__fabEnterDone___3_diU{opacity:1}.FAB__fabExitDone___2zlm9{display:none}", ""]);
// Exports
exports.locals = {
	"fabContainer": "FAB__fabContainer___B78WX",
	"fabEnter": "FAB__fabEnter___2GA_Y",
	"fabEnterActive": "FAB__fabEnterActive___3HH_X",
	"fabExitActive": "FAB__fabExitActive___1YD43",
	"fabExitDone": "FAB__fabExitDone___2zlm9",
	"fabEnterDone": "FAB__fabEnterDone___3_diU"
};
module.exports = exports;
